import { IonButton, IonCol, IonGrid, IonHeader, IonIcon, IonImg, IonModal, IonRow, IonToolbar } from "@ionic/react";
import { closeOutline, cloudUploadOutline, imageOutline } from "ionicons/icons";
import { Trans } from "react-i18next";
import { mapsServices } from "../store/services";

interface ImagesPopupProps {
	parent: any; // Reference to the parent class component (this)
	nodes: any[];
	edges: any[];
	reactFlowInstance: any;
	toggleImagesCaptions: () => void;
	saveAndExit: (param: boolean) => void;
	drawingPencil: any; // icon;
}

export default function ImagesPopup({ parent, nodes, edges, reactFlowInstance, toggleImagesCaptions, saveAndExit, drawingPencil }: ImagesPopupProps) {
	const text_to_image = (source: string) => {
		const image = document.createElement("img");
		image.id = `image-${parent.state.selectedNodeId}`;
		image.src = source;
		image.style.maxWidth = "150px";
		for (let i = 0; i < document.getElementsByClassName("react-flow__node").length; i++) {
			if ((document.getElementsByClassName("react-flow__node")[i] as HTMLElement).getAttribute("data-id") === parent.state.selectedNodeId) {
				(document.getElementsByClassName("react-flow__node")[i] as HTMLElement).appendChild(image);
			}
		}
	};

	return (
		<IonModal
			isOpen={parent.state.showImagesPopover}
			className="mapsImagePickerPopover"
			onDidDismiss={() => {
				parent.setState({
					showContentPopover: false,
					popoverEvent: null,
					showImagesPopover: false,
					selectedNodeHasImage: false,
					wordPicture: "",
					wordCustomImage: null,
				});
			}}
		>
			<IonHeader>
				<div className="imagePopup-topBar">
					<div className="imagePopup-btn-container">
					<p className="imagePickerPopoverTitle">
						<Trans>Scegli un immagine da associare al nodo o:</Trans>
					</p>
					<div className="mapImagePickerBtn-container">
					<div
						className="mapImagePickerBtn"
						onClick={async () => {
							let nodesToPush: any[] = [];
							let edgesToPush: any[] = [];

							if (reactFlowInstance) {
								nodes.forEach((node: any) => {
									nodesToPush.push({
										id: node.id,
										label: node.data ? node.data.label : node.label,
										color: node.color ? node.color : node.style ? node.style.backgroundColor : null,
										position: node.position,
										image: node.image ? node.image : null,
									});
								});

								edges.forEach((edge: any) => {
									edgesToPush.push(edge);
								});

								let currentNodeText = nodes.filter((node: any) => node.id === parent.state.selectedNodeId)[0].data.label;
								parent.props.history.push({
									pathname: "/sketch",
									state: {
										selectedNodeId: parent.state.selectedNodeId ? parent.state.selectedNodeId : null,
										documentId: parent.state.documentId,
										docTitle: parent.state.docTitle,
										word: currentNodeText.trim(),
										drawing: parent.state.imageSearchResponse.filter((image: string) => image === parent.state.wordPicture)[0],
									},
								});
							}
						}}
					>
						<Trans>
							{parent.state.wordPicture === "" ? "Crea " : "Modifica "}
							disegno
						</Trans>
						<IonIcon icon={drawingPencil} size="large" />
					</div>

					<div
						className="mapImagePickerBtn"
						onClick={async () => {
							if (parent.state.wordCustomImage) {
								console.log("delete");
								mapsServices
									.deleteDrawing(parent.state.userUuid, parent.state.bearerToken, parent.state.currentNodeText.split(" ").slice(0, 5).join(" "))
									.then(() => {
										const updatedImages = parent.state.imageSearchResponse.slice(1);

										parent.setState({
											imageSearchResponse: updatedImages,
											wordCustomImage: false,
										});
									});
							} else {
								document.getElementById("utilsFileInput")?.click();
							}
						}}
					>
						<Trans>
							{!parent.state.wordCustomImage ? "Carica " : "Rimuovi "}
							immagine
						</Trans>
						<IonIcon slot="end" icon={!parent.state.wordCustomImage ? cloudUploadOutline : imageOutline} />
					</div>
					</div>
					</div> 

					<IonIcon
					className="imagePopup-closeBtn"
						slot="end"
						size="large"
						icon={closeOutline}
						style={{ cursor: "pointer" }}
						onClick={() => {
							parent.setState({
								showContentPopover: false,
								popoverEvent: null,
								showImagesPopover: false,
								selectedNodeHasImage: false,
							});
						}}
					/>
				</div>
			</IonHeader>

			<IonGrid style={{ overflowY: "scroll" }}>
				<IonRow>
					{parent.state.imageSearchResponse &&
						parent.state.imageSearchResponse.length > 0 &&
						parent.state.imageSearchResponse
							.filter((image: string) => image && typeof image === "string") // Skip undefined
							.map((image: string, key: number) => {
								console.log(image);
								return (
									<IonCol key={key} size="4">
										<IonImg
											onClick={() => {
												text_to_image(`${image.startsWith("https://") ? image : "data:image/png;base64," + image}`);
												parent.setState({
													showContentPopover: false,
													showImagesPopover: false,
													isNodeSelected: false,
													selectedNodeId: "",
												});
												if (!parent.props.showImagesCaptions) {
													toggleImagesCaptions();
												}
												(nodes.filter((node: any) => node.id === parent.state.selectedNodeId)[0] as any).image = image;
												saveAndExit(false);
											}}
											key={key}
											className="imagePopup-img"
											src={`${image.startsWith("https://") ? image : "data:image/png;base64," + image}`}
										/>
									</IonCol>
								);
							})}
				</IonRow>

				<div
					className="mapImgsPopup"
					style={{
						textAlign: "center",
						display: "flex",
						flexDirection: "column",
					}}
				>
					{parent.state.imageSearchResponse?.length === 0 && (
						<p>
							<Trans>Non ci sono immagini da assegnare al nodo</Trans>
						</p>
					)}
				</div>
			</IonGrid>
		</IonModal>
	);
}
